module.exports = __webpack_public_path__ + "static/media/bg3.9d67eaaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minibg/bg3.jpg
// module id = 585
// module chunks = 0